import { useUrlFilters } from "../../urlFilter";
import { selectedFilterParser } from "../helpers";
import { ISelectedFilterMap } from "../types";
import { useFilterMap } from "./useFilterMap";

export const useSelectedFilterMap = (): ISelectedFilterMap => {
  const filterMap = useFilterMap();
  const urlFilters = useUrlFilters();
  return selectedFilterParser(filterMap, urlFilters);
};
